import React from "react";
import {CardImage, CardWrapper, TextArea, Wrapper,} from '@/components/organisms/top3CreditCard/Top3CreditCard.styled';
import {Button, Subtitle} from '@/components/atoms';
import {ITop3Item} from '@/types';

const Top3CreditCard = (props: ITop3Item) => {
  const {cardImagePath, onClick, rank, cardName, desc1, supportText} = props;

  return (
    <Wrapper>
      <CardWrapper>
        <CardImage src={cardImagePath} alt="top 3 card image"/>
      </CardWrapper>
      <TextArea>
        <Subtitle level={3} color="primary-100">
          {rank}위
        </Subtitle>
        <Subtitle level={1} color="gray-800" ellipsis>
          {cardName}
        </Subtitle>
        <Subtitle level={6}>{desc1}</Subtitle>
      </TextArea>
      {supportText && (
        <Button full onClick={onClick}>
          {""}{supportText}
        </Button>
      )}
    </Wrapper>
  );
};

export default React.memo(Top3CreditCard);
